import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import CreateLessonPlan from './screens/CreateLessonPlan.jsx';
import LessonGeneratorSelection from './screens/LessonGeneratorSelection.jsx';
import Dashboard from './screens/Dashboard.jsx';
import DisplayLessonPlan from './screens/DisplayLessonPlan.jsx';
import ViewLessonPlan from './screens/ViewLessonPlan.jsx';
// HIDDEN: Assessment feature temporarily disabled
// import AssessmentEditor from './screens/AssessmentEditor.jsx';
// import ViewAssessment from './screens/ViewAssessment.jsx';
import SelectElements from './screens/SelectElements.jsx';
import MyPlans from './screens/MyPlans.jsx';
import Resources from './screens/Resources.jsx';
import AboutHelp from './screens/AboutHelp.jsx';
// HIDDEN: Quiz feature temporarily disabled
// import QuizLessonSelector from './screens/QuizLessonSelector.jsx';
// import DisplayQuiz from './screens/DisplayQuiz.jsx';
// import ViewQuiz from './screens/ViewQuiz.jsx';
import Button from './components/Button.jsx';
import styles from './App.css';
import { FileProvider } from './components/FileContext';
import { AuthProvider } from './components/AuthContext';
import { FeedbackProvider } from './contexts/FeedbackContext';
import FeedbackPanel from './components/FeedbackPanel';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage from './screens/LandingPage.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <FeedbackProvider>
          <Router>
            <ScrollToTop />
            <FileProvider>
              <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              {/* Skip intermediate lesson-generator selection; go straight to form (augment + quiz flows are hidden). */}
              <Route path="/create-lesson-plan" element={<Navigate to="/create-lesson-plan/form" replace />} />
              <Route path="/create-lesson-plan/form" element={<CreateLessonPlan />} />
              <Route path="/select-elements" element={<SelectElements />} />
              <Route path="/display-lesson-plan" element={<DisplayLessonPlan />} />
              <Route path="/view-lesson-plan" element={<ViewLessonPlan />} />
              {/* HIDDEN: Assessment routes temporarily disabled */}
              {/* <Route path="/assessment-editor" element={<AssessmentEditor />} /> */}
              {/* <Route path="/view-assessment" element={<ViewAssessment />} /> */}
              <Route path="/my-plans" element={<MyPlans />} />
              <Route path="/generated-material" element={<MyPlans />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/about-help" element={<AboutHelp />} />
              {/* HIDDEN: Quiz routes temporarily disabled */}
              {/* <Route path="/generate-quiz" element={<QuizLessonSelector />} /> */}
              {/* <Route path="/quiz/:quizId" element={<DisplayQuiz />} /> */}
              {/* <Route path="/view-quiz/:quizId" element={<ViewQuiz />} /> */}
            </Routes>
            </FileProvider>
          </Router>
          <FeedbackPanel />
        </FeedbackProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
